/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import ArgosFlexbox from '../../Containers/ArgosFlexbox';
import {IArgosReportSectionProps} from '../constants';


/**
 * Renders a Image collapse section in the FullReport view displaying
 * the image from a byte string.
 */
const Image = (props: IArgosReportSectionProps) => {
  const {data} = props

  return(
    <ArgosFlexbox vertical style={{padding: "10px"}}>
      <figure style={{maxWidth: '100%'}}>
        <img src={`data:image/png;base64,${data.image}`} alt={data.caption} style={{maxWidth: '100%'}} />
        <figcaption>{data.caption}</figcaption>
      </figure>
    </ArgosFlexbox>
  )
}

export default Image
